export const MyApi = {
  BASE_URL: "https://agilesoft.co.in/demo/taxiservicesvaranasi/api/",
  // BASE_URL: "http://localhost/a/taxiservicesvaranasi.com/api/",
  SECRET_KEY: "123456789",

  SITE_SETTING: "site-setting",
  CAT_MENU: "cat-menu",
  BANNER_LIST: "bannerlist",
  CMS_PAGE: "pages/",

  // TOUR_PACKAGES: "products-with-parent-category",
  TOUR_PACKAGES: "popular-tour",
  Our_Cars: "local-tour",
  Our_servicess: "our-services",
  TOUR_LIST: "tours-list",
  TOUR_DETAILS: "tour-details",

  CLIENTS_LOGO: "ClientsLogo",
  CONTACT_PAGE: "contact-page",
  FAQLIST: "faqpage",
  BLOGLIST: "BlogpageLists",
  BLOGDETAILS: "blog-detail",

  GALLERY_CAT: "gallery-cat",
  VIDEO_GALL: "video-gallery",
  TESTIMONIAL_API: "submit-testimonial",
  TESTIMONIAL_GET: "get-testimonials",
  ENQUIRY_FORM: "enquiry-form",
  ENQUIRY_FORM_book: "enquiry-form-book-taxi",
  // GALLERY_VIEW: "gallery-list",
};
